<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'ecom-awsBiz-skuFlipReview',
  components: { PageTable },
}
</script>
